import { GET_ONE } from "admin-on-rest";
import {uniq} from 'lodash';
import { RestClient } from "../restClient";

//const cartesianProduct = (elements, name, price,nameProduct) => {
const cartesianProduct = (elements, name, price, brandProduct, slugProduct) => {
  if (!Array.isArray(elements)) {
    throw new TypeError();
  }
  const end = elements.length -1;
  const result = [];
  function addTo(curr, start) {
    var first = elements[start],
      last = (start === end);
    for (var i = 0; i < first.length; ++i) {
      var copy = curr.slice();
      copy.push(first[i]);
      if (last) {
        //  console.log(copy);
        const variant = setVariantObject(copy, name, price, brandProduct, slugProduct);
        // console.log(variant);
        result.push(variant);
      } else {
        addTo(copy, start + 1);
      }
    }
  }

  if (elements.length) {
    addTo([], 0);
  } else {
    result.push([]);
  }

  return result;
}
//const setVariantObject = (copy, name, price, nameProduct) => {
const setVariantObject = (copy, name, price, brandProduct, slugProduct) => {
  var newOptions = {}; 
  var variants = {};
  var newName = '';
  copy.map((item, index) => {
    var obj = {};
    obj[name[index]] = item;
    newName += item+' ';
    newOptions[name[index]] = item;
    return obj;
  });
  // const nameP = nameProduct.trim().split(' ').join('-');
  const nameP = brandProduct.trim().split(' ').join('-');
  const nameS = slugProduct.trim().split(' ').join('-');
  const nameV = newName.trim().split(' ').join('-');
  const globalName = nameP+'-'+nameS+'-'+nameV;
  variants['qty'] = 1;
  variants['sku'] = globalName.toLowerCase();
  variants['name'] = newName.trim();
  variants['price'] = price;
  variants['active'] = true;
  variants['variant'] = newOptions;

  return variants;
}

//export const getVariants = (elements, price,nameProduct) => {
export const getVariants = (elements, price,brandProduct, slugProduct) => {
  if (!Array.isArray(elements)) {
    throw new TypeError();
  }
  const end = elements.length -1;
  const contentOptions = [];
  const contentName = [];
  for (var j = 0; j <= end; j++) {
      const item = elements[j];
      contentOptions.push(item.values);
      contentName.push(item.name);
  }
  
  const result = cartesianProduct(contentOptions, contentName, price, brandProduct, slugProduct);
  return result;

}

export const getCategory = (state, id) => {
  const categories = 'categories';
  const resources = 'resources';
  let refenceCategories = null;
  if((state.admin[resources]) && (state.admin[resources].categories)){
      const stateCategories = state.admin[resources].categories;
    if((stateCategories.data) && (stateCategories.data[id])){
      refenceCategories = stateCategories.data[id];
      console.log("masuk 2");
      return refenceCategories;
    } else {
      RestClient(GET_ONE, "categories", { id: id })
      .then(items => {
        if (items.data && items.data.name) {
          let categories = items.data;
          console.log("masuk 3");
          console.log(items.data);
          return categories;
        }
      })
      .catch(e => {
        console.error(e);
      });
      console.log("masuk 4");
    }
  } else if(state.admin[categories]){
    console.log("masuk 5");
    if((state.admin[categories].data) && (state.admin[categories].data[id])){
      refenceCategories = state.admin[categories].data[id];
      console.log("masuk 6");
      return refenceCategories;
    } else {
      console.log("masuk 7");
      RestClient(GET_ONE, "categories", { id: id })
      .then(items => {
        if (items.data && items.data.name) {
          let categories = items.data;
          console.log("masuk 8");
          return categories;
        }
      })
      .catch(e => {
        console.error(e);
      });
      
    }
  }else {
    console.log("masuk 9");
    RestClient(GET_ONE, "categories", { id: id })
      .then(items => {
        if (items.data && items.data.name) {
          console.log("masuk 10");
          let categories = items.data;
          return categories;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  return refenceCategories;
}

export const getCategoriesList = (properties, categories) => {
  const dataProperties = [];
  const dataCategories = [];
  for (var key in properties) {
    if (properties.hasOwnProperty(key)) {
      dataProperties.push(key);
    }
  }
  
  for (var key1 in categories) {
    if (categories.hasOwnProperty(key1)) {
      dataCategories.push(categories[key1]); 
    }
  }
  dataProperties.push.apply(dataProperties, dataCategories); 
  return uniq(dataProperties);
}


export const isVariant = (variant, name, nameProduct) => {
  if(( variant && (variant.options) && (variant.options.length > 0)) && (name && (name !== ''))){
    if((variant.options[0].name) && (nameProduct !== '')) {
      return true;
    }
  }
  return false;
}


export const isEqual = (value, other) => {

	// Get the value type
	const type = Object.prototype.toString.call(value);

	// If the two objects are not the same type, return false
	if (type !== Object.prototype.toString.call(other)) return false;

	// If items are not an object or array, return false
	if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

	// Compare the length of the length of the two items
	const valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
	const otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
	if (valueLen !== otherLen) return false;

	// Compare two items
	const compare = function (item1, item2) {

		// Get the object type
		const itemType = Object.prototype.toString.call(item1);

		// If an object or array, compare recursively
		if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
			if (!isEqual(item1, item2)) return false;
		}

		// Otherwise, do a simple comparison
		else {

			// If the two items are not the same type, return false
			if (itemType !== Object.prototype.toString.call(item2)) return false;

			// Else if it's a function, convert to a string and compare
			// Otherwise, just compare
			if (itemType === '[object Function]') {
				if (item1.toString() !== item2.toString()) return false;
			} else {
				if (item1 !== item2) return false;
			}

		}
	};

	// Compare properties
	if (type === '[object Array]') {
		for (let i = 0; i < valueLen; i++) {
			if (compare(value[i], other[i]) === false) return false;
		}
	} else {
		for (let key in value) {
			if (value.hasOwnProperty(key)) {
				if (compare(value[key], other[key]) === false) return false;
			}
		}
	}

	// If nothing failed, return true
	return true;

};




// WEBPACK FOOTER //
// ./src/products/utils.js